import { Tabs, TabsContent, TabsList, TabsTrigger } from '@consigli/shadcn';
import { useState } from 'react';

import { Select, timeRangeOptions } from '@/components';
import { useTabParam } from '@/utils/use-tab-param';

import { FlagsTab } from './flags/flags-tab';
import { OverviewTab } from './overview/overview-tab';
import { SessionReader } from './session-reader/session-reader';
import { SessionsTab } from './sessions/sessions-tab';

const TAB_VALUES = ['overview', 'sessions', 'flags'] as const;
type TabValue = (typeof TAB_VALUES)[number];

const TIME_RANGES = timeRangeOptions.filter(
  (option) => option.value === 'LAST_7D' || option.value === 'LAST_30D',
);

interface OpenedSession {
  conversationId: string;
  turnId?: string;
}

export const BeamstarPage = () => {
  const [selectedTab, setSelectedTab] = useTabParam<TabValue>('overview', TAB_VALUES);
  const [timeRange, setTimeRange] = useState(TIME_RANGES[0]);
  const [openedSession, setOpenedSession] = useState<OpenedSession | null>(null);

  const openSession = (conversationId: string, turnId?: string) =>
    setOpenedSession({ conversationId, turnId });

  return (
    <>
      <Tabs
        value={selectedTab}
        onValueChange={(value) => setSelectedTab(value as TabValue)}
        className="w-full"
      >
        <div className="relative mb-8 flex items-center justify-between">
          <h2 className="text-4xl font-bold">Beamstar</h2>
          <div className="absolute left-1/2 -translate-x-1/2">
            <TabsList className="bg-gray-200">
              <TabsTrigger value="overview" className="px-6">
                Overview
              </TabsTrigger>
              <TabsTrigger value="sessions" className="px-6">
                Sessions
              </TabsTrigger>
              <TabsTrigger value="flags" className="px-6">
                Flags
              </TabsTrigger>
            </TabsList>
          </div>
          <Select
            options={TIME_RANGES}
            value={timeRange}
            onValueChange={setTimeRange}
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.value}
          />
        </div>
        <TabsContent value="overview">
          <OverviewTab days={timeRange.days} />
        </TabsContent>
        <TabsContent value="sessions">
          <SessionsTab days={timeRange.days} onOpenSession={openSession} />
        </TabsContent>
        <TabsContent value="flags">
          <FlagsTab days={timeRange.days} onOpenTurn={openSession} />
        </TabsContent>
      </Tabs>
      {openedSession && (
        <SessionReader
          conversationId={openedSession.conversationId}
          targetTurnId={openedSession.turnId}
          onClose={() => setOpenedSession(null)}
        />
      )}
    </>
  );
};
